import request from '../request'

export default {
    getPermisos() {
        return request.get('permiso')
    },
    getPermisosTipos() {
        return request.get('permiso_tipo')
    },
    updatePermiso(permisoData) {
        return request.put('permiso', permisoData)
    }
}
